import Swiper from 'swiper/swiper-bundle';
export const initializeSwiper = () => {

  const tamatabiTopSwiper = new Swiper(document.querySelector<HTMLDivElement>('.js-tamatabi-top-slider'), {
    freeMode: true,
    loop: true,
    loopedSlides: 6,
    slidesPerView: 2.5,
    speed: 10000,
    allowTouchMove: false,
    autoplay: {
      delay: 0,
    },
    on: {
      slideChangeTransitionStart: function(){
        this.wrapperEl.style.transitionTimingFunction = 'linear';
      }
    },

    breakpoints: {
      768: {
        loopedSlides: 6,
        slidesPerView: 4,
      }
    }
  })

  const newPostSwiper = new Swiper(document.querySelector<HTMLDivElement>('.js-new-post-slider'), {
    direction: 'horizontal',
    slidesPerView: 1,
    spaceBetween: 20,
    centeredSlides: true,
    loop: true,
    disableOnInteraction: false,

    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },

    pagination: {
      el: ".swiper-pagination",
      clickable: true
    },

    scrollbar: {
      el: '.swiper-scrollbar',
    },

    breakpoints: {
      768: {
        slidesPerView: 2.4,
      },
      460: {
        slidesPerView: 2,
      }
    }
  })

  const aboutLineUpSwiper = new Swiper(document.querySelector<HTMLDivElement>('.js-about-line-up-slider'), {
    freeMode: true,
    loop: true,
    loopedSlides: 6,
    slidesPerView: 2.5,
    speed: 10000,
    allowTouchMove: false,
    autoplay: {
      delay: 0,
    },
    spaceBetween: 8,
    on: {
      slideChangeTransitionStart: function(){
        this.wrapperEl.style.transitionTimingFunction = 'linear';
      }
    },

    breakpoints: {
      768: {
        loopedSlides: 6,
        slidesPerView: 4,
      }
    }
  })

  const courseThumbnail = new Swiper(".js-course-thumbnail", {
    spaceBetween: 10,
    slidesPerView: 5,
    loop: true,
    freeMode: true,
    watchSlidesProgress: true
  });

  const courseMainSlider= new Swiper(".js-course-main-slider", {
    spaceBetween: 10,
    loop: true,
    navigation: {
      nextEl: ".js-swiper-button-next",
      prevEl: ".js-swiper-button-prev"
    },
    thumbs: {
      swiper: courseThumbnail
    }
  });
};
